module.exports = __webpack_public_path__ + "img/logo-peace-beta.0ed28938.png";